import { ITANSAR_LEGAL } from './itansar-legal-documents'

/**
 * Короткие ключи для форм и футера. URL задаются в `itansar-legal-documents.ts`.
 * Для ansarium.tech — см. `ansarium/src/shared/config/ansarium-legal-documents.ts`.
 */
export const LEGAL_LINKS = {
    terms: ITANSAR_LEGAL.termsOfUse.url,
    privacy: ITANSAR_LEGAL.privacyPolicy.url,
    cookies: ITANSAR_LEGAL.cookiePolicy.url,
    personalData: ITANSAR_LEGAL.consentPersonalData.url,
} as const

export { ITANSAR_LEGAL } from './itansar-legal-documents'
